const setToken = (token = '') => sessionStorage.setItem('token', token);
const removeToken = () => sessionStorage.removeItem('token');

export {
    setToken,
    removeToken
};